import { API } from 'aws-amplify';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export function CreateDepartments(body:any, query:any)
{
	return API.post('departments', `/department${query}`, { body });
}
export function getDepartments(query:any)
{
	return API.get('departments', `/department${query}`, init);
}
export function deptEmployeeCount(queryStringParameters:any)
{
	return API.get('departments', '/deptEmployees', { queryStringParameters });
}
export function upatedDepartments(id:any, body:any, query:any)
{
	return API.put('departments', `/department/${id}${query}`, { body });
}
export function deleteDepartment(id:any, name:any, query:any)
{
	return API.del('departments', `/department/${id}/${query}`, init);
}
export function CreateRelations(body:any, query:any)
{
	return API.post('departments', `/relations${query}`, { body });
}
export function getRelations(query:any)
{
	return API.get('departments', `/relations${query}`, init);
}
export function upatedRelations(body:any, query:any)
{
	return API.put('departments', `/relations${query}`, { body });
}
export function deleteRelations(id:any, query)
{
	return API.del('departments', `/relations/${id}${query}`, init);
}
export function CreateDesignation(body:any, query)
{
	return API.post('departments', `/designation${query}`, { body });
}
export function getDesignation(query:any)
{
	return API.get('departments', `/designation${query}`, init);
}
export function upatedDesignation(id:any, body:any, query:any)
{
	return API.put('departments', `/designation${query}`, { body });
}
export function deleteDesignation(id:any, query:any)
{
	return API.del('departments', `/designation/${id}${query}`, init);
}
export function CreateDivision(body:any, query)
{
	return API.post('departments', `/division${query}`, { body });
}
export function getDivision(id:any, query:any)
{
	return API.get('departments', `/division/${id}${query}`, init);
}
export function deleteDivision(id:any, query:any)
{
	return API.del('departments', `/division/${id}${query}`, init);
}
export function divisionManagement(body:any, query)
{
	return API.put('departments', `/division${query}`, { body });
}
export function getDepartmentView(query:any)
{
	return API.get('departments', `/department${query}`, init);
}
export function getDepartDesigDivision(query:any)
{
	return API.get('departments', `/departDesigDivision${query}`, init);
}
export function getIndustriesList(queryStringParameters): Promise<any>
{
	return API.get('departments', '/getIndustries', { queryStringParameters });
}

export function getParentRelations(query:any)
{
	return API.get('departments', `/getConnectedRelations${query}`, init);
}